export const REDEN_VAN_STATUS_IN_AANMAAK = "1";
export const REDEN_VAN_STATUS_INACTIEF = "2";
export const REDEN_VAN_STATUS_INGEDIEND = "121450000";
export const MAN = "121450000";

export const HAS_CONCURRENCY_EXCEPTION = "HAS_CONCURRENCY_EXCEPTION";
export const HAS_VALIDATION_ERRORS_SAVED = "HAS_VALIDATION_ERRORS_SAVED";
export const HAS_VALIDATION_ERRORS = "HAS_VALIDATION_ERRORS";
export const HAS_FILE_EXCEPTION = "HAS_FILE_EXCEPTION";
export const SUCCESS = "SUCCESS";
export const PDF_GENEREREN = "PDF_GENEREREN";
export const PDF_SIMULATIE_GENEREREN = "PDF_SIMULATIE_GENEREREN";

export const FederatieDropdown = {
    NIET_AANGESLOTEN: "niet-aangesloten"
};

export const DomainScopes = {
    ELOKET: "e-loket",
    ZOEKMOTOR: "zoekmotor"
};

export const DocumentScopes = {
    ELOKET: "eloket",
    ZOEKMOTOR: "zoekmotor"
};

export const DocumentComponents = {
    DEMO: "demo_component",
    SJABLOON_DEMO: "sjabloon_demo",
    LUS: "lus_component"
};

export const VTTTabs = {
    DEMO: 'demoTab',
    ORGANISATOR: 'organisatorTab',
    TOCHTTAB: 'tochtTab',
    LUSTAB: 'lusTab'
};

export const SportkampenTypes = {
    OVERZICHT: "OVERZICHT",
    DEELNEMERS: "DEELNEMERS",
    ATTESTENKANSENGROEPEN: "ATTESTENKANSENGROEPEN"
};

export const AccountTypes = {
    ORGANISATOR: "121450000",
    KOEPELORGANISATIE: "121450001",
    GEMEENTE: "121450002",
    FEDERATIE: "121450003",
};

export const RechtspersoonlijkheidTypes = {
    VZW: 121450000,
    FEITELIJKE_VERENIGING: 121450001,
    ANDERE: 121450002
};

export const BronTypes = {
    MANUEEL: 121450000,
    DATAWAREHOUSE_SCHOLEN: 121450001,
    MAGDA_ONDERNEMINGEN: 121450002,
    MAGDA_VERENIGINGEN: 121450003
};

export const ToelatingTypes = {
    ANB: 121450000,
    GEMEENTE: 121450001,
    AWV: 121450005,
    ANDERE: 121450004
};

export const TochtBehandelaars = {
    SPORTVLAANDEREN: 'f3e1fe31-06d8-ec11-a7b5-0022489ef118',
    //EAGLEBE: '91bdd344-06d8-ec11-a7b5-0022489ef118'
};

export const Landen = {
    BELGIE: "0e5db0e6-e457-e611-80de-c4346bacceb8"
};

export const TochtRedenVanStatus = {
    InAfwachtigingVanGoedkeuringDoorFedKoepel: 121450000,
    AfgekeurdDoorFedKoepel: 121450001,
    InAfwachtigingVanGoedkeuringDoorSVL: 121450002,
    AfgekeurdDoorSVL: 121450003,
    DossierOnvolledig: 121450004,
    DossierVolledig: 121450005,
    DoorgestuurdTerGoedkeuring: 121450006,
    MachtigingNietOK: 121450007,
    MachtigingOK: 121450008,
    Gepubliceerd: 121450009,
    GoedgekeurdDoorSVL: 121450010
};

export const TochtFrequentieTypes = {
    EENMALIG: 121450000,
    JAARLIJKS: 121450001
};

const ANDERE_FIETSTOCHT = "62de288e-2c75-f111-ab0d-000d3ad95530";
const ANDERE_LOOPTOCHT = "74970caf-1776-f111-ab0d-000d3ad95530";

export const LusTypeIds = {
    ANDERE_FIETSTOCHT,
    ANDERE_LOOPTOCHT,
    ANDERE: [ANDERE_FIETSTOCHT, ANDERE_LOOPTOCHT]
};

export const TochtTypeIds = {
    FIETSTOCHT: "6e5de03b-2c75-f111-ab0d-000d3ad95530",
    LOOPTOCHT: "ea1aba08-2c75-f111-ab0d-000d3ad95530",
    WANDELTOCHT: "4ecfdd41-2c75-f111-ab0d-000d3ad95530",
    GEMOTORISEERDE_TOCHT: "0448f91a-2c75-f111-ab0d-000d3ad95530",
    MENNEN: "ead26f27-2c75-f111-ab0d-000d3ad95530",
    MUSHING: "f6dd1d2e-2c75-f111-ab0d-000d3ad95530",
    RUITERTOCHT: "78001934-2c75-f111-ab0d-000d3ad95530"
};

export const Environments = {
    LOCAL: "LOCAL",
    SDEV: "SDEV",
    PPD: "PPD",
    PRD: "PRD"
};
